import { render, staticRenderFns } from "./CashierDetail.vue?vue&type=template&id=bf450988&scoped=true"
import script from "./CashierDetail.vue?vue&type=script&lang=js"
export * from "./CashierDetail.vue?vue&type=script&lang=js"
import style0 from "./CashierDetail.vue?vue&type=style&index=0&id=bf450988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf450988",
  null
  
)

export default component.exports